import { createPaginationHook } from '../../services/apollo/pagination';

import {
  LivePostItemFragmentDoc,
  LivePostItemFragment,
} from './Event.fragment.generated';
import {
  LiveGetPostsDocument,
  LiveGetPostsQueryVariables,
  LiveGetPostsLoadMoreDocument,
  LiveGetPostsLoadMoreQueryVariables,
  LiveGetLastPostsQueryVariables,
  LiveGetLastPostsDocument,
} from './Event.query.generated';
import { LiveListenNewMessagesDocument } from './Event.subscription.generated';

const postsPagination = createPaginationHook<LivePostItemFragment>({
  paginationFieldName: 'readPaginatedPosts',
  filter: (ref, readField, { variables }) => {
    const liveId = readField('live_id', ref);
    return liveId === variables?.liveId;
  },
  sort: (refA, refB, readField) => {
    const createdDateA = readField<string>('_created', refA);
    const createdDateB = readField<string>('_created', refB);

    if (createdDateA === createdDateB) {
      return 0;
    }

    if (!createdDateA) {
      return 1;
    }

    if (!createdDateB) {
      return -1;
    }

    return createdDateB.localeCompare(createdDateA);
  },
  fragment: LivePostItemFragmentDoc,
  isRefresh: true,
});

export const useEventPostsInit = (variables: LiveGetPostsQueryVariables) => {
  const livePostsQuery = postsPagination.usePaginateItems({
    queryOptions: {
      query: LiveGetPostsDocument,
      variables: variables,
      context: {
        role: 'anonymous',
      },
      skip: !variables.liveId,
    },
    normalize: (data) => {
      const posts = data.data.lives_post;
      const limit = variables.limit || 10;

      return {
        startCursor: posts?.[0],
        endCursor:
          posts?.length >= limit ? posts?.[posts?.length - 1] : undefined,
      };
    },
  });

  return livePostsQuery;
};

export const useEventPostsLoadMore = (
  variables: Partial<LiveGetPostsLoadMoreQueryVariables>
) => {
  const loadMoreQuery = postsPagination.useLoadMore({
    queryOptions: {
      query: LiveGetPostsLoadMoreDocument,
      context: {
        role: 'anonymous',
      },
      variables,
    },
    normalize: (data) => data.data?.lives_post,
    normalizeVariables: (variables, { cursor, lastCall }) => ({
      ...variables,
      date: cursor?._created || lastCall,
      id: cursor?.id || -1,
    }),
  });

  return loadMoreQuery;
};

export const useEventPostsAutoRefresh = ({
  ...variables
}: Partial<LiveGetLastPostsQueryVariables> & {}) => {
  // let refreshMode = 'disabled';
  // if (variables.liveId && event) {
  //   if (event.status === 'live') {
  //     refreshMode = 'subscription';
  //   } else {
  //     refreshMode = 'polling';
  //   }
  // }
  const refreshQuery = postsPagination.useAutoRefresh({
    queryOptions: {
      query: LiveGetLastPostsDocument,
      context: {
        role: 'anonymous',
      },
      variables,
      // pollInterval:
      //   refreshMode === 'polling'
      //     ? isToday(parseISO(event!.date))
      //       ? 5 * 1000
      //       : 30 * 1000
      //     : 0,
      pollInterval: 0,
      skip: true,
    },

    syncQueryOptions: {
      query: LiveListenNewMessagesDocument,
      context: {
        role: 'anonymous',
      },
      variables: {
        liveId: variables.liveId,
      },
      skip: true,
    },
    // lives_post est directement dans data, contrairement à celui de useEventPostsLoadMore
    normalize: (data) => data.lives_post,
    normalizeVariables: (variables, { cursor, lastCall }) => ({
      ...variables,
      date: cursor?._created || lastCall || new Date(),
      id: cursor?.id || -1,
    }),
  });

  return refreshQuery;
};
